<template>
  <div id="page-tips-shifts" class="d-flex">
    <!--<MainBarMenuV2 />-->
    <div class="layout-content container-fluid">
      <!--<HeadingUser />-->
      <div class="page-tips-shift tab-filtros">
        <div class="content-loader" v-if="loadingNovelties">
          <div id="loader2"></div>
          <div class="cssload-dots">
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
          </div>
        </div>
        <div class="content-loader" v-if="loadingNoveltiesDetail">
          <!--div class="loader-novelty"></div-->
          <div id="loader2"></div>
          <div class="cssload-dots">
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
            <div class="cssload-dot"></div>
          </div>
        </div>
        <!--div class="container"-->
        <div class="row">

          <div class="col-12 m-0 p-0">
            <button class="button-secundary" style="margin-left: auto;
margin-bottom: 10px;
margin-right: 15px;
position: realtive;
width: 121px;
height: 40px;
border-radius: 100px;" v-b-toggle.accordion-1 variant="light">
              <span class="when-opened">
                Filtros
                <img class=" pl-0" src="@/assets/images/icons/filter.svg">
              </span>
              <span class="when-closed">
                Filtros
                <img class=" pl-0" src="@/assets/images/icons/filter.svg">
              </span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <b-collapse id="accordion-1" class="filtros" accordion="my-accordion" role="tabpanel" align="left">
              <b-card-body class=" mb-3 tab-filtros2">
                <div class="row" style="flex-wrap:inherit;margin-right: 0px;">
                  <div class="col-md-4 pl-8" style="margin-left: 16px">
                    <span class="cta ml-8" style="color: #5d5fef">Estado de novedad</span>
                    <div class="linea"></div>
                    <div class="m-3">
                      <input v-model="status" type="checkbox" @change="getFilterDp_status($event)" id="checkbox-1"
                        name="checkbox-1" value="1">
                      <label for="checkbox-1">
                        <img class="leftImg1 mr-3" src="@/assets/images/icons/pendiente.svg">
                      </label>
                    </div>
                    <div class="m-3">
                      <input v-model="status" type="checkbox" @change="getFilterDp_status($event)" id="checkbox-2"
                        name="checkbox-2" value="2">
                      <label for="checkbox-2">
                        <img class="leftImg1 mr-3" src="@/assets/images/icons/cerrado.svg">
                      </label>
                    </div>
                    <div class="m-3">
                      <input v-model="status" type="checkbox" @change="getFilterDp_status($event)" id="checkbox-3"
                        name="checkbox-3" value="3">
                      <label for="checkbox-3">
                        <img class="leftImg1 mr-3" src="@/assets/images/icons/rechazado.svg">
                      </label>
                    </div>
                    <!--b-form-checkbox
                        id="checkbox-1"
                        class="ml-0"
                        v-model="status"
                        name="checkbox-1"
                        value="1"
                        @change="getFilterDp_status($event)"
                      >
                        <img
                          class="leftImg1"
                          src="@/assets/images/icons/pendiente.svg"
                        />
                      </b-form-checkbox>
                      <b-form-checkbox
                        id="checkbox-2"
                        class="ml-0"
                        v-model="status"
                        name="checkbox-2"
                        value="2"
                        @change="getFilterDp_status($event)"
                      >
                        <img
                          class="leftImg1"
                          src="@/assets/images/icons/cerrado.svg"
                        />
                      </b-form-checkbox>
                      <b-form-checkbox
                        id="checkbox-3"
                        class="ml-0"
                        v-model="status"
                        name="checkbox-3"
                        value="3"
                        @change="getFilterDp_status($event)"
                      >
                        <img
                          class="leftImg1"
                          src="@/assets/images/icons/rechazado.svg"
                        />
                      </b-form-checkbox-->
                  </div>
                  <div class="col-md-4 ml-0">
                    <span class="cta" style="color: #5d5fef">Punto de venta</span>
                    <div class="linea"></div>
                    <div class="col-md-5">
                      <div class="buscar-empleado mt-4 mb-4">
                        <div class="input-group-prepend">
                          <span class="icon">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M8.1665 0.666656C12.3065 0.666656 15.6665 4.02666 15.6665 8.16666C15.6665 12.3067 12.3065 15.6667 8.1665 15.6667C4.0265 15.6667 0.666504 12.3067 0.666504 8.16666C0.666504 4.02666 4.0265 0.666656 8.1665 0.666656ZM8.1665 14C11.389 14 13.9998 11.3892 13.9998 8.16666C13.9998 4.94332 11.389 2.33332 8.1665 2.33332C4.94317 2.33332 2.33317 4.94332 2.33317 8.16666C2.33317 11.3892 4.94317 14 8.1665 14ZM15.2373 14.0592L17.0051 15.8263C17.3308 16.1519 17.3309 16.6798 17.0053 17.0054C16.6797 17.331 16.1517 17.331 15.8262 17.0053L14.059 15.2375L15.2373 14.0592Z"
                                fill="#546E7A" />
                            </svg>
                          </span>
                        </div>
                        <input type="search" placeholder="Buscar punto de venta" aria-label="Buscar punto de venta"
                          autocomplete="off" class="form-control body_regular" v-model="pro_point_sale_id"
                          style="border: 0px" @keypress="getFilterDp" />
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <!--img
                        class="rightImg1"
                        src="@/assets/images/onboarding/add_information.svg"
                      /-->
                  </div>
                  <!--div class="col-md-3">
                    <b-button  @click="getFilterDp" class="text-center mb-4 mt-4" size="lg" variant="success">
                      Aplicar filtro
                    </b-button>
                    <br>
                  </div-->
                </div>
              </b-card-body>
            </b-collapse>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="ml-2 mt-2 mb-1 mr-0">
              <datatable :columns="datatable.columns" :data="novelties.data.data" :per-page="datatable.perPage"
                :page="datatable.page" class="table table-hover table-borderless ">
                <template scope="{ row, columns }">
                  <tr :class="[row.selected ? 'selection-table' : '']" @dblclick="selectRow(row)">
                    <template>
                      <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row"
                        class="cell-border"></datatable-cell>
                    </template>
                  </tr>
                </template>
              </datatable>
              <div class="
                    col-12
                    cont-pagination
                    my-5
                    d-flex
                    justify-content-center
                  ">
                <Pagination :data="novelties.data" :limit="10" @pagination-change-page="getFilterDp"></Pagination>
              </div>
            </div>
          </div>
        </div>
        <!-- .row -->

        <!-- modal -->
        <b-modal id="modal-scoped" size="xl" centered>
          <template>
            <div v-if="this.novedad_selected != null" class="title-detail mb-4">
              Detalle de la Novedad (
              {{ this.novedad_selected.pro_point_sale }} -
              {{ this.novedad_selected.fecha }})
            </div>

            <div class="ml-2 mt-2 mb-1 mr-0 ">
              <datatable :columns="detalledatatable.columns" :data="this.detailnoveltiesDatatable"
                :per-page="detalledatatable.perPage" :page="detalledatatable.page"
                class="table table-hover table-borderless mt-4" id="detalle" style="box-shadow: none;">
                <template scope="{ row, columns }">
                  <tr :class="[row.selected ? 'selection-table' : '']" @click="selectRowDetail(row)">
                    <template>
                      <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row" class="">
                      </datatable-cell>
                    </template>
                  </tr>
                </template>
              </datatable>
            </div>
            <div class="col-md-12 mt-2">
              <div class="text-left ml-2 mr-4 text-novedad-descripcion">
                <b>Acerca de esta novedad</b>
              </div>
              <b-form-group label-for="textarea" class="mr-4 label-textarea">
                <b-form-textarea id="textarea" v-model="descripcion" class="ml-4 textarea-novedad" rows="5"
                  :disabled="novedad_selected.status != 1 ? true : false"></b-form-textarea>
              </b-form-group>
            </div>
          </template>

          <template #modal-footer="{}" class="text-center">
            <div class="col-12 text-center" v-if="novedad_selected.status == 1">
              <b-overlay :show="loadingNoveltiesDetailModal" rounded opacity="0.6" spinner-variant="primary"
                class="d-inline-block mr-4">
                <button class="p-2 button-primary" :disabled="loadingNoveltiesDetailModal" @click="confirmar()">
                  <span> Confirmar novedad </span>
                </button>
              </b-overlay>

              <b-overlay :show="loadingNoveltiesDetailModal" rounded opacity="0.6" spinner-variant="primary"
                class="d-inline-block ml-4">
                <button class="button-danger" :disabled="loadingNoveltiesDetailModal" variant="outline-danger"
                  @click="rechazar()">
                  <span>Rechazar novedad</span>
                </button>
              </b-overlay>
            </div>
            <div></div>
          </template>
        </b-modal>

        <b-modal id="modal-confirm" size="ls" centered @hidden="resetnovedades">
          <template>
            <div class="col-12 text-center mb-4">
              <h1 style="font-size: 100px; color: #0c9e42">
                <span class="icon icon-checkmark"></span>
              </h1>
              <b v-if="success.message != ''">{{ success.message }}</b>
            </div>
          </template>

          <template #modal-footer="{}" class="text-center">
            <div class="col-12 text-center">
              <b-button pill class="text-center" size="lg" variant="success" @click="entendido()">
                Entendido
              </b-button>
            </div>
          </template>
        </b-modal>
        <!--/div-->
        <!-- .layout-content -->
      </div>
    </div>
  </div>

  <!-- #page-request -->
</template>

<script>
import EstadoNovedades from "@/components/datatables/EstadoNovedades.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import serverConfig from "../../services/config";
import Pagination from "laravel-vue-pagination";

export default {
  name: "tipspayrollnews",
  components: {
    Pagination,
  },
  data() {
    return {
      zonas: [],
      zona: {},
      modelZona: null,
      linedeals: [],
      linedeal: {},
      checklinedeal: [],
      isActive: false,
      employeeSearch: "",
      selectedEmployees: [],
      descripcion: "",
      status: [],
      pro_point_sale_id: null,
      filter: null,
      checkedNames: [],
      novedad_selected: {
        status: null,
      },
      // Modal
      modal_title: "¡Tu reporte se ha realizado exitosamente!",
      modal_msg:
        "No olvides que tu reporte de novedad depende de la confirmación de tu jefé de Zona",
      modal_class: "icon icon-success text-success",

      // Listado de novedades
      datatable: {
        total: 18,
        filter: "",
        perPage: 9,
        last_page: 2,
        page: 1,
        columns: [
          {
            label: "Fecha",
            field: "fecha",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Punto de venta",
            field: "pro_point_sale",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Nombre y Apellidos",
            field: "full_name",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Tipo novedad",
            field: "tipo_novedad",
            align: "right",
            headerClass: "text-right",
          },
          {
            label: "Estado novedad",
            field: "status",
            align: "right",
            headerClass: "text-right",
            component: EstadoNovedades,
          },
        ],
        rows: [],
      },

      // detalle
      detalledatatable: {
        total: 18,
        filter: "",
        perPage: 9,
        last_page: 2,
        page: 1,
        columns: [
          {
            label: "Nombre y Apellidos",
            field: "full_name",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Novedad",
            field: "tipo_novedad",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "PDV origen",
            field: "pdv_origen",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "PDV remplazo",
            field: "pdv_reemplazo",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Cargo origen",
            field: "cargo_origen",
            align: "left",
            headerClass: "text-left",
          },
          {
            label: "Cargo reemplazo",
            field: "cargo_reemplazo",
            align: "left",
            headerClass: "text-left",
          },
        ],
        rows: [],
      },

      selected: [], // Must be an array reference!
      checked: null,
      text: "",
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
    };
  },

  watch: {},

  beforeMount() {
    //this.obtenerZonas();
    this.actGetLineDeals();
    this.obtenerNovedades();
  },
  computed: {
    ...mapState("modCore", ["user", "userData"]),
    ...mapState("modTipshiftReportHistory", ["turnos", "loadingH"]),
    ...mapState("modPlatformSettings", ["zones"]),
    ...mapState("modNovelties", [
      "loadingNovelties",
      "novelties",
      "detailnovelties",
      "loadingNoveltiesDetail",
      "detailnoveltiesDatatable",
      "loadingNoveltiesDetailModal",
    ]),

    ...mapState("modReportTips", [
      "propinasGeneral",
      "loading",
      "listLineDeals",
    ]),

    ...mapGetters("modNovelties", ["getAllDetailNoveltiesDatatable"]),
  },

  methods: {
    ...mapActions("modRequest", ["actGetSettings"]),

    ...mapActions("modPlatformSettings", ["actGetZones"]),

    ...mapActions("modTipshiftReportHistory", ["actGetTurnos"]),

    ...mapActions("modNovelties", [
      "actGetNovelties",
      "actGetDetailNovelties",
      "toggleDetail",
      "confirmNoveltie",
    ]),

    ...mapActions("modReportTips", [
      "actGetPropinasGeneral",
      "actSetComponentePropinas",
      "actGetLineDeals",
    ]),

    limpiar() {
      // Estados
      let check = document.getElementsByClassName("checkEstado");
      check.forEach((element) => {
        element.checked = false;
      });
      this.status = [];
      this.pro_point_sale_id = null;
      this.checklinedeal = [];
      this.filter = null;
    },

    resetnovedades() {
      this.obtenerNovedades();
    },

    obtenerZonas() {
      let data = {
        page: 1,
      };
      this.actGetZones(data).then(() => {
        this.zonas = this.zones.data.data;
      });
    },

    obtenerNovedades() {
      // Obtener las novedades
      let dataNov = {
        status: this.status,
        pro_point_sale_id: this.pro_point_sale_id,
      };
      this.actGetNovelties(dataNov).then(() => {
        this.datatable.rows = this.novelties.data.data;
      });
    },

    selectRow(row) {
      // Buscar contenido
      this.novedad_selected = row;
      let data = {
        id_novedad: this.novedad_selected.id,
        status: null,
      };
      this.actGetDetailNovelties(data).then(() => {
        // Inicializar el campo de descripcion
        this.descripcion = this.detailnovelties.data.description;
        // Llenar la tabla
        this.detalledatatable.rows = this.detailnovelties.data;

        this.$bvModal.show("modal-scoped");
      });
    },

    selectRowDetail(row) {
      // Seleccionar registro
      this.toggleDetail(row).then(() => { });
    },
    getFilterDp_status(flag) {

      // alert(this.status);
      console.log(flag);

      //this.status = flag;
      //this.status = this.status;
      let dataNov = {
        status: this.status,
        pro_point_sale_id: this.pro_point_sale_id,
        page: 1,
        filter: this.filter,
      };
      this.actGetNovelties(dataNov).then(() => {
        this.datatable.rows = this.novelties.data.data;
      });
    },
    getFilterDp(page = 1) {
      // Obtener las novedades
      let dataNov = {
        status: this.status,
        pro_point_sale_id: this.pro_point_sale_id,
        page: page,
        linedeal: this.checklinedeal,
        filter: this.filter,
      };
      this.actGetNovelties(dataNov).then(() => {
        this.datatable.rows = this.novelties.data.data;
      });
    },

    getFilterDpDetail(page) {
      // Buscar contenido
      let data = {
        id_novedad: this.novedad_selected.id,
        status: null,
        page: page,
      };
      this.actGetDetailNovelties(data).then(() => {
        // Inicializar el campo de descripcion
        this.descripcion = this.detailnovelties.data[0].description;
        // Llenar la tabla
        this.detalledatatable.rows = this.detailnovelties.data;
      });
      this.$bvModal.show("modal-scoped");
    },

    entendido() {
      this.$bvModal.hide("modal-confirm");
    },

    confirmar() {
      // CONFIRMAR DATOS
      let data = {
        id: this.novedad_selected.id,
        status: 2,
      };
      this.confirmNoveltie(data).then((res) => {
        this.$bvModal.hide("modal-scoped");
        this.$bvModal.show("modal-confirm");
        this.success.message = res.message;
      });
    },

    rechazar() {
      // CONFIRMAR DATOS
      let data = {
        id: this.novedad_selected.id,
        status: 3,
      };
      this.confirmNoveltie(data).then((res) => {
        this.$bvModal.hide("modal-scoped");
        this.$bvModal.show("modal-confirm");
        this.success.message = res.message;
      });
    },

    selected_checkbox1() {
      let Checkbox2 = document.getElementById("checkbox-2");
      Checkbox2.checked = false;
      this.status[0] = 1;
    },
    selected_checkbox2() {
      let Checkbox1 = document.getElementById("checkbox-1");
      Checkbox1.checked = false;
      this.status[0] = 2;
    },

    selected_checklinedeal(idname, id) {
      let check = document.getElementsByClassName("checklinedeal");
      this.checklinedeal = [];
      check.forEach((element) => {
        if (element.id != idname) {
          element.checked = false;
        } else {
          this.checklinedeal[0] = id;
        }
      });

      console.log(this.checklinedeal, id);
    },
  },
};
</script>
<style lang="scss" scoped>
//@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');


.page-tips-shift {

  .filter {
    border: solid rgb(207, 207, 207) 1px;
    border-radius: 10px;
    background-image: url("../../assets/images/icons/vector-seacrh-filter.svg");
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 12%;
    width: 100%;
    height: 159px;

    h3 {
      font-weight: 600;
      color: #1c6776;
    }
  }

  .title-3 {
    font-size: 24px;
    font-weight: bold;
    color: #1c3a4e;
  }

  .cont-request-text {
    .cont-title {
      color: #1c3a4e;

      .title-1 {
        font-size: 40px;
        font-weight: bold;
      }

      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }

    .form-request {
      /*.button1 {
        font-family: "Open Sans";
        background: #E9ECEE;
        color: #1C3A4E;
        font-weight: bold;
        height: 32px;
        font-size: 14px;
        text-align: left !important;   
        padding-left: 5%;
        padding-right: 5%;
        outline: none;
        border: none;
        &:hover {
          background: darken(#cddce6, 5);
          border: none;
        }
      }*/

      .button2 {
        background: #8d9092;
        color: #ffffff;
        border-color: #8d9092;
        font-family: "Poppins";
        border-radius: 100px;
        height: 42px;
        width: 220px;
        font-size: 14px;
        text-align: center !important;
        padding-left: 2%;
        padding-right: 2%;

        &:hover {
          background: darken(#7a7c7e, 5);
        }

        .button3 {
          border-radius: 50px;
          font-family: "Open Sans";
          color: #1c3a4e;
          font-size: 20px;
          border: 0 none;
          outline: none;
          text-decoration: none;
          border: 2px solid #1c3a4e;
        }
      }
    }
  }

  .p1 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
  }

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #979494;
    text-align: center !important;
  }

  .p3 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    color: #999797;
  }

  .center {
    display: flex;
    align-items: center;
  }

  .button4 {
    background: #99a6af;
    color: #ffffff;
    border-radius: 8px;
    height: 20px;
    font-size: 8px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;

    &:hover {
      background: darken(#99a6af, 5);
    }
  }

  .collapsed>.when-opened,
  :not(.collapsed)>.when-closed {
    display: none;
  }

  .centerImg2 {
    vertical-align: middle;
    position: relative;
    bottom: 2px;
    padding-right: 2%;
  }

  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }

  .mycheck {
    width: 1.3em;
    height: 1.3em;

    border-radius: 30%;
    vertical-align: middle;
    border: 1px solid #ddd;
   // -webkit-appearance: none;
  }

  .mycheck:checked {
    background-color: #1c3a4e;
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked+.slider {
    background-color: #779b49;
  }

  input:focus+.slider {
    box-shadow: 0 0 1px #779b49;
  }

  input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .style-filter .vs__search::placeholder,
  .style-filter .vs__dropdown-toggle,
  .style-filter .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
    font-size: 11px;
    line-height: 12px;
  }

  .style-filter .vs__clear,
  .style-filter .vs__open-indicator {
    fill: #394066;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }

  .card-header {
    background-color: none !important;
  }

  .chips {
    /* Auto Layout */
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    width: 61px;
    left: calc(50% - 61px / 2 - 127.5px);
    top: 0%;
    bottom: 0%;
    /* Alert / Error Bg */
    background: #feefef;
    border-radius: 4px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .iconClose {
    /* Alert/Error */
    color: #da1414;
  }

  .iconPendiente {
    /* Alert/Error */
    color: #e06100;
  }

  .iconProceso {
    /* Alert/Error */
    color: #2e5aac;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  .textClose {
    position: static;
    height: 16px;
    left: 22px;
    right: 4px;
    top: calc(50% - 16px / 2);
    /* Placeholder */
    font-family: Open Sans;
    font-style: italic;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    /* Alert/Error */
    color: #da1414;
  }

  .card-header {
    background: #edf9f0;
    border-bottom: none;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;
  }

  .card-header-text {
    /* Header Tablas */
    font-family: Open Sans;
    font-style: normal;

    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #0c9e42;
  }

  .card-personalizada {
    flex-direction: column;
    background: #ffffff;
    /* Neutral / Gray 3 */

    border: 1px solid #dddddd;
    box-sizing: border-box;
    /* leve */
    box-shadow: 0px 6px 24px rgb(110 116 134 / 12%);
    border-radius: 8px;
  }

  .card-left {
    /* Auto Layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 0px 16px;
    /* Neutral / White */
    background: #ffffff;
    /* Neutral / Gray 3 */
    border: 1px solid #dddddd;
    box-sizing: border-box;
    /* up extra */
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
  }

  .card-text-name {
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 1 */
    color: #454545;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 4px;

    /* Elipsis nombre */
    width: 120px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .ancho-completo {
    width: 100%;
  }

  .card-text-name-bodega {
    /* Body Tablas - Párrafo mediano */
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 1 */
    color: #454545;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 0px 4px;

    /* Elipsis nombre */
    width: 50%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }

  .text-proceso {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #1c3a4e;
  }

  .text-pendiente {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #1c3a4e;
  }

  .chips-bodega-pendiente {
    /* Auto Layout */
    text-align: right;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    left: calc(50% - 61px / 2 - 127.5px);
    top: 0%;
    bottom: 0%;
    width: 100px;
    /* Alert / Error Bg */
    background: #fff4ec;
    border-radius: 20px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .chips-bodega-proceso {
    /* Auto Layout */
    text-align: right;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    position: static;
    left: calc(50% - 61px / 2 - 127.5px);
    top: 0%;
    bottom: 0%;
    width: 100px;
    /* Alert / Error Bg */
    background: #eef2fa;
    border-radius: 20px;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 16px;
  }

  .card-body {
    padding-top: 10px;
    padding-left: 0px;
    padding-bottom: 10px;
  }

  .card-text-cargo {
    /* Body Tablas - Párrafo mediano */

    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: right;

    /* Neutral / Gray 1 */

    color: #454545;

    /* Inside Auto Layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 0px 4px;

    // Elipsis cargo
    width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }



  .card-left-titulo {
    /* Header Tablas */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    /* Primary / 1 */
    color: #1c3a4e;
  }

  table {
    //border-collapse: collapse;
    border-spacing: 0;
    border-collapse: separate;
    border-radius: 8px !important;
  }

  thead>tr {
    /*flex-direction: column;
      align-items: flex-start;*/
    padding: 0px;
    /* Alert / Info Bg */
    //background: #EEF2FA;

    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin: 0px 0px;

    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* Neutral / Black */
    color: #000000;
  }

  tbody>tr {
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* Neutral / Gray 1 */
    color: #454545;
  }

  table>input {
    border: 1px solid #aaaaaa;
    box-sizing: border-box;
    border-radius: 2px;
    background: #269887;
  }

  .selection-table {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    border-radius: 8px;
  }

  .custom-control-input:checked~.custom-control-label::before {
    color: #fff;
    border-color: #269887;
    background-color: #269887;
  }

  .checkbox-blue:checked~.checkbox-blue::before {
    color: #fff;
    border-color: #269887;
    background-color: #269887;
  }

  /*.btn {
    background: #269887;
    border: transparent;
  }

  .btn:hover {
    background: #1c6776;
    border: transparent;
  }*/

  .text-novedad-info {
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */
    display: flex;
    align-items: center;
    text-align: center;
    /* Primary / 3 */
    color: #269887;
  }

  // Tabla de reemplazos, rotativos, editar puntaje
  .tabs-novedades {
    .col-auto {
      background-color: transparent;
    }

    ul {
      background-color: transparent;
    }

    .nav-item {
      background-color: transparent;
      border-bottom: 1px solid #e9ecee;
      width: 180px;

      a {
        color: black;
      }
    }

    .nav-pills {
      margin-left: 0px;
      padding-left: 0px;
      margin-top: 10px;
    }

    .nav-link {
      height: 80px;
      margin-left: 0px;
      padding-left: 0px;
      background-color: transparent;
      /* Botón */
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height */
      letter-spacing: 0.02em;
    }

    .nav-pills .nav-link.active,
    .nav-pills .show>.nav-link {
      color: black;
      background-color: white;
      /* Neutral / Black */
      color: #000000;
    }

    .page-tips-shift .tabs .nav-link {
      /* Botón */
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      /* identical to box height */
      letter-spacing: 0.02em;
      /* Neutral / Black */
      color: #000000;
      background-color: white;
    }

    .tab-title-content {
      height: 60px;
      padding-left: 5px;
      //border-left: 4px solid transparent;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .nav-link.active>.tab-title-content {
      border-left: 4px solid #269887;
    }

    .tab-title-muted-ul {
      margin: 0px;
      padding: 0px;
    }

    .tab-title-muted {
      /* Body Semibold */
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      /* Primary / 3 */
      color: #269887;
    }

    .tab-title-r {
      color: #269887;
      //margin-top: 15px;
      vertical-align: middle;
    }

    .tab-title-r-10 {
      color: #269887;
      margin-top: 3px;
    }

    .card-header {
      background-color: none !important;
    }

    .card {
      background-color: none !important;
      border-color: none !important;
      border: 0px !important;
    }

    .card-header-novedad {
      /* Header Tablas */
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      /* identical to box height */
      color: #2f3d46;
      background: #f5f5f5;
    }

    .text-novedad-descripcion {
      /* Header Tablas */
      font-family: Open Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;
      /* Neutral / Gray 1 */
      color: #454545;
    }

    .text-novedad-buscar {
      /* Body Tablas - Párrafo mediano */
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      /* identical to box height */
      display: flex;
      align-items: center;
      justify-content: center;
      /* Neutral / Gray 1 */
      color: #454545;
    }
  }

  .text-buscar {
    background: #ffffff;
    /* Neutral / Gray 3 */
    border: 1px solid #dddddd;
    box-sizing: border-box;
    border-radius: 8px;

    .input-group-prepend {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .icon-search1 {
      color: #dadada;
    }

    .icon-search1::before {
      display: flex;
      align-items: center;
      justify-content: center;
      vertical-align: center;
    }

    input {
      height: 40px;
      border: 0px;
      margin-left: -10px;
    }

    ::placeholder {
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #aaaaaa;
    }
  }

  .label-textarea {
    margin-top: 0px;
  }

  .label-textarea label {
    width: 150px;
    position: relative;
    top: 20px;
    left: 30px;
    margin-top: 0px;
    border-radius: 1px;
    background: white;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    display: flex;
    align-items: center;
    /* Neutral / Gray 2 */
    color: #aaaaaa;
    text-align: left;
  }

  .textarea-novedad {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #454545;

    background: #ffffff;
    border: 1px solid #aaaaaa;
    box-sizing: border-box;
    border-radius: 8px;
    width: 98%;
    height: 92px;
    margin-top: 10px;
    padding-top: 10px;
    scroll-behavior: auto;

    ::placeholder {
      margin-top: 100px;
    }
  }

  .reloj-letras {
    position: absolute;
    top: 31%;
    left: 7%;

    /* Subtítulos */
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    /* Neutral / White */
    color: #ffffff;
  }

  .contenedor-quitar {
    width: 100%;
  }

  .ver-historial {
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    /* Primary / 3 */
    color: #269887;
  }

  .btn-descartar {
    /* Primary / 3 */
    background: white;
    border-radius: 100px;
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #da1414;
  }

  .btn-descartar:hover {
    /* Primary / 3 */
    background: white;
    border-radius: 100px;
    /* Body Semibold */
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #da1414;
  }

  .alert-custom-danger {
    /* Alert / Warning Bg */
    background: #fff4ec;
    border-radius: 8px;
    /* Body Tablas - Párrafo mediano */
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    /* Neutral / Black */
    color: #000000;
    border: 0px;
  }
}

/* Center the loader */
.loader-novelty {
  position: relative;
  z-index: 1072;
  left: 30%;
  top: 30%;
  z-index: 1;

  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.content-loader {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1071;
  background-color: #fff;
  opacity: 0.9;
}

.title-detail {
  /* Subtítulos */
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  /* identical to box height */

  text-align: center;

  /* Primary / 1 */

  color: #1c3a4e;
}

/*#detalle {
   table {
      //border-collapse: collapse;
      border-radius: 8px !important;
    }

    thead > tr{
        flex-direction: column;
        align-items: flex-start;
        padding: 0px;
        /* Alert / Info Bg */
/*  background: #EEF2FA;
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
        margin: 0px 0px;

        /* Body Tablas - Párrafo mediano */
/*    font-family: Open Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 19px;
        /* Neutral / Black */
/*    color: #000000;
    }

    tbody > tr{
      /* Body Tablas - Párrafo mediano */
/*  font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      /* Neutral / Gray 1 */
/*     color: #454545;
    }

    table > input {
      border: 1px solid #AAAAAA;
      box-sizing: border-box;
      border-radius: 2px;
      background: #269887;
    }

    .selection-table{
      /* Neutral / Gray blue light */
/*     background: #F5F5F5;
      border-radius: 8px;
    }
}*/

.icon-circle-check {
  color: #779b49;
}

.icon-circle-clock {
  color: #e48d3d;
}

.icon-cancel-circle {
  color: #e4433d;
}

.filtros-open {
  width: 1002px;
}


.filtros {

  display: flex;
  width: 100%;
  height: 216px;

  margin-bottom: 24px;

  flex-direction: column;

  /* content/00 */

  background: #FFFFFF;
  /* Bottom */
  //background-image: url("../../assets/images/icons/vector-seacrh-filter.svg");
  background-image: url("../../assets/images/onboarding/add_information.svg");
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 20%;

  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14);
  border-radius: 12px;
}

.linea {
  padding: 15px 5px;
  margin-top: 10px;
  border-top: 1px solid #cfd8dc;
  -o-border-image: linear-gradient(to right,
      rgba(66, 87, 119, 0) 5%,
      #cfd8dc 5%,
      #cfd8dc 95%,
      rgba(66, 87, 119, 0) 95%);
  border-image: linear-gradient(to right,
      rgba(66, 87, 119, 0) 5%,
      #cfd8dc 5%,
      #cfd8dc 95%,
      rgba(66, 87, 119, 0) 95%);
  border-image-slice: 1;
}

.data_picker {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px !important;

  position: relative;
  height: 44px !important;
  left: 0px;
  right: 0px;
  //top: 8px;

  /* content/00 */

  background: #ffffff !important;
  /* content/03 */

  border: 1px solid #b0bec5 !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
  margin-bottom: 16px !important;
  margin-top: 16px !important;
  float: right;

  button {
    position: absolute;
    right: inherit;
  }
}


.rightImg1 {
  position: absolute;
  right: 0;
  top: -10px;
  border-radius: 16px;
  height: 216px;
}

.text-buscar {
  background: #ffffff;
  /* Neutral / Gray 3 */
  border: 1px solid #b0bec5;
  box-sizing: border-box;
  border-radius: 22px !important;

  .input-group-prepend {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .input-group {
    width: 50px !important;
  }

  .icon-search1 {
    color: #dadada;
  }

  .icon-search1::before {
    display: flex;
    align-items: center;
    justify-content: center;
    vertical-align: center;
  }

  input {
    height: 40px;
    border: 0px;
    margin-left: -10px;
    margin-right: 15px;
    width: 300px;
  }

  ::placeholder {
    //font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    color: #aaaaaa;
  }
}

.input-checkbox+label:before {
  content: "";
  display: inline-block;
}

.buscar-empleado {
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;

  position: static;
  width: 428px;
  height: 44px;
  left: calc(50% - 428px / 2);
  top: calc(50% - 44px / 2);

  background: #ffffff;
  /* content/03 */

  border: 1px solid #b0bec5;
  border-radius: 8px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 1;
  margin: 0px 0px;
}

.buscar-empleado .form-control {
  border: 0px !important;
  font-family: Ubuntu !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 28px !important;
  width: 428px;
}

.leftImg1 {
  //width: 16px;
  //height: 16px;
  vertical-align: middle;
  // margin-top: 24px;
  margin-left: 10px !important;
}

.rightImg1 {
  position: relative;
  right: -130px;
  top: -8px;
  border-radius: 16px;
  height: 216px;
}

.card {
  background-color: none !important;
  border-color: none !important;
  border: 0px !important;


}

input[type="checkbox"] {
  display: none;


}

input[type="checkbox"]+label {

  margin-left: 25px;

}

input[ type=checkbox]+label:before {
  content: "";
  display: inline-block;


  width: 20px;
  height: 20px;


  border: 1px solid #7A7CFF;
  box-sizing: border-box;
  border-radius: 2px;
  text-align: center;
  vertical-align: text-top;
  line-height: 15px;
  margin: 3px 12px -3px 1px;
  padding: 0px;
  position: realtive;
  left: 28px;

}


input[ type=checkbox]:checked+label:before {
  content: "\02713";
  //font-size:10px;
  background: #5D5FEF;
  border-radius: 2px;
  color: #fff;

}

input[ type=checkbox]:focus+label:before {
  box-shadow: 0px 0px 3px 1px #ccc;
}

input[ type=checkbox]:hover+label:before {
  box-shadow: 0px 0px 4px #5D5FEF;
}

/* clears the 'X' from Internet Explorer */
input[type=search]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

input[type=search]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the 'X' from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}
</style>
<style>
.custom-control-label {
  /* position: relative; */
  margin-bottom: 0;
  vertical-align: top;
  left: 0px !important;
}

.leftImg1 {

  vertical-align: middle;
  margin-left: 10px !important;
}

#checkbox-3:checked~.custom-control-label::before {
  content: "\02713" !important;
}
</style>